import {
    FETCH_LIST,
    TENANT_COUPON_FETCHED,
    SHOW_INFO_DIALOG,
    TOGGLE_LOADING,
    SHOW_COUPON_STATS_DIALOG
  } from './actionTypes'
  
  export const fetchList = (tenantd, params) => ({
    type: FETCH_LIST,
    payload: {
      tenantd,
      params
    }
  })
  
  export const tenantCouponsFetched = result => ({
    type: TENANT_COUPON_FETCHED,
    payload: result
  })
  
  export const showInfoDialog = params => ({
    type: SHOW_INFO_DIALOG,
    payload: { params }
  })


  export const toggleLoading = () => ({
    type: TOGGLE_LOADING
  })

  export const showCouponStatsDialog = params => ({
    type: SHOW_COUPON_STATS_DIALOG,
    payload: { params }
  })
